import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalsService } from './globals';
@Injectable({
  providedIn: 'root',
})
export class CausesService {
  url: string = this.globals.apiUrl;
  constructor(private http: HttpClient, private globals: GlobalsService) {}
  private header(): HttpHeaders {
    return new HttpHeaders({
      Authorization: 'Bearer ' + this.globals.user.token,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    });
  }
  public getMethods(planId) {
    return this.http.get(
      this.url + `/api/plan-pda/${planId}/metodo-analisis-pda`,
      {
        headers: this.header(),
      }
    );
  }
  public getMethod(planId) {
    return this.http.get(this.url + `/api/plan-pda/${planId}/metodo`, {
      headers: this.header(),
    });
  }
  public addMethod(planId, body) {
    return this.http.post(
      this.url + `/api/plan-pda/${planId}/metodo-analisis-pda`,
      body,
      {
        headers: this.header(),
      }
    );
  }
  public saveMethods(body) {
    return this.http.post(this.url + `/api/plan-pda/metodo`, body, {
      headers: this.header(),
    });
  }

  public deleteMethod(planId, methodId) {
    return this.http.delete(
      this.url + `/api/plan-pda/${planId}/metodo-analisis-pda/${methodId}`,
      {
        headers: this.header(),
      }
    );
  }
  public getCausasGenerales(planId) {
    return this.http.get(this.url + `/api/plan-pda/${planId}/causa-general`, {
      headers: this.header(),
    });
  }
  public saveCausasGenerales(planId,body) {
    return this.http.post(this.url + `/api/plan-pda/${planId}/causa-general`, body, {
      headers: this.header(),
    });
  }
}
